import { createSlice } from "@reduxjs/toolkit";

const initialOrgStructureData = {
  completeData: [],
};

const orgStructureSlice = createSlice({
  name: "orgStructureData",
  initialState: initialOrgStructureData,
  reducers: {
    setOrgStructureData: (_state, action) => action.payload,
    addOrgStructureData: (state, action) => {
      state.completeData.unshift(action.payload);
    },
    updateOrgStructureData: (state, action) => {
      state.completeData = state.completeData.map((data) => (data.id === action.payload.id ? action.payload : data));
    },
    removeOrgStructureData: (state, action) => {
      state.completeData = state.completeData
        .filter((data) => !action.payload.includes(data.id))
        .map((data) => {
          if (action.payload.includes(data.reportsTo)) {
            return {
              ...data,
              reportsTo: "",
              reportsToName: "",
            };
          }
          return data;
        });
    },
    reorderOrgStructureData: (state, action) => {
      state.completeData = state.completeData.map((data) =>
        data.id === action.payload.id ? { ...data, parentId: action.payload.parentId } : data,
      );
    },
  },
});

export const {
  setOrgStructureData,
  addOrgStructureData,
  updateOrgStructureData,
  removeOrgStructureData,
  reorderOrgStructureData,
} = orgStructureSlice.actions;

export const orgStructureData = orgStructureSlice.reducer;

const projectAttachedPositionSlice = createSlice({
  name: "projectAttachedPosition",
  initialState: [],
  reducers: {
    setProjectAttachedPosition: (_state, action) => action.payload,
  },
});

export const { setProjectAttachedPosition } = projectAttachedPositionSlice.actions;

export const projectAttachedPosition = projectAttachedPositionSlice.reducer;
